import { useContext, createContext } from 'react';
import { User } from './useAuth';

const defaultValue = {
  userData: null,
  fetchUserData: async () => {},
  pending: false,
  authorized: false,
  loaded: false,
  azTests: {
    disableRatingMechanics: true,
    enabledFunctionalLiteracyTasks: false,
    enabledSafeTerritoryTasks: false,
    enabledInfoKpk: false,
    showVectorSurvey: false,
    allowAutoOpenVectorSurvey: false,
  },
  fetchFeatures: async () => {},
};

export const AuthContext = createContext<{
  userData: User | null;
  fetchUserData: () => Promise<void>;
  pending: boolean;
  authorized: boolean;
  loaded: boolean;
  azTests: {
    disableRatingMechanics: boolean;
    enabledFunctionalLiteracyTasks: boolean;
    enabledSafeTerritoryTasks: boolean;
    enabledInfoKpk: boolean;
    showVectorSurvey: boolean; //Разрешает показ опроса про Вектор роста на главной
    allowAutoOpenVectorSurvey: boolean; //Разрешает автоматически открывать модалку с опросом про Вектор роста
  };
  fetchFeatures: () => Promise<void>;
}>(defaultValue);

export const useAuthContext = () => useContext(AuthContext);
